import { MentionableBackendPlugin } from '../../../../types'

// Context tool values - used for filtering context tools consistently
export const CONTEXT_PLUGINS = ['search_audio_notes', 'search_knowledge', 'search_highlights']

// REFACTOR(umut): Hardcoding these for now, but we should get these from the chat backend
export const backendPluginsList: Array<MentionableBackendPlugin> = [
  {
    label: 'Linear',
    value: 'linear',
    images: {
      image: 'https://cdn.highlightai.com/media/icons/linear.svg',
    },
    type: 'backend_plugin',
    isPro: false,
  },
  {
    label: 'Notion',
    value: 'notion',
    images: {
      image: 'https://cdn.highlightai.com/media/icons/notion.svg',
    },
    type: 'backend_plugin',
    isPro: false,
  },
  // Disable for now because it's not working and is causing confusion. Should be reenabled once fixed.
  // {
  //   label: 'Slack',
  //   value: 'slack',
  //   images: {
  //     image: 'https://cdn.highlightai.com/media/icons/slack.svg',
  //   },
  //   type: 'backend_plugin',
  // },
  {
    label: 'Google Calendar',
    value: 'google_calendar',
    images: {
      image:
        'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a5/Google_Calendar_icon_%282020%29.svg/240px-Google_Calendar_icon_%282020%29.svg.png',
    },
    type: 'backend_plugin',
    isPro: false,
  },
  {
    label: 'Image Generation',
    value: 'imagegen',
    images: {
      image:
        '<svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.1851 0.0893555C18.1113 0.0894297 18.8116 0.32727 19.2866 0.802246C19.7617 1.27138 19.9995 1.96297 19.9995 2.87744V13.1226C19.9995 14.0371 19.7617 14.7286 19.2866 15.1978C18.8116 15.6728 18.1113 15.9106 17.1851 15.9106H2.81494C1.89448 15.9106 1.19343 15.6728 0.712402 15.1978C0.237543 14.7286 0.000492538 14.0369 0.000488281 13.1226V2.87744C0.000537411 1.96314 0.237502 1.27138 0.712402 0.802246C1.19343 0.327157 1.89448 0.0893876 2.81494 0.0893555H17.1851ZM2.94873 1.86182C2.57465 1.86182 2.28639 1.95985 2.08447 2.15576C1.88848 2.35175 1.79053 2.64945 1.79053 3.04736V11.9292L4.03564 9.92432C4.20786 9.76993 4.38003 9.65386 4.55225 9.57666C4.7304 9.49947 4.9178 9.46143 5.11377 9.46143C5.30968 9.46146 5.5029 9.50234 5.69287 9.58545C5.8887 9.66261 6.07538 9.77886 6.25342 9.93311L7.8042 11.3413L11.6079 7.93799C11.7979 7.76583 11.9968 7.64118 12.2046 7.56396C12.4183 7.48086 12.6411 7.439 12.8726 7.43896C13.0923 7.43896 13.3092 7.48371 13.5229 7.57275C13.7427 7.6559 13.9453 7.78333 14.1294 7.95557L18.2183 11.7749V3.04736C18.2183 2.64946 18.1174 2.35175 17.9155 2.15576C17.7136 1.95982 17.4253 1.86186 17.0513 1.86182H2.94873ZM7.07861 2.479C7.16144 2.47911 7.23314 2.50687 7.29346 2.56201C7.3539 2.6149 7.39117 2.68581 7.40381 2.77393C7.47187 3.25039 7.54441 3.65185 7.62256 3.97705C7.7007 4.30214 7.80318 4.56963 7.9292 4.77881C8.05522 4.98534 8.22025 5.15048 8.42432 5.27393C8.63103 5.39744 8.89242 5.49575 9.20752 5.56885C9.52508 5.63939 9.91437 5.70148 10.3755 5.75439C10.4637 5.76448 10.5372 5.80075 10.5952 5.86377C10.6531 5.92423 10.6821 5.99788 10.6821 6.0835C10.682 6.1664 10.653 6.23939 10.5952 6.30225C10.5372 6.36275 10.4637 6.39861 10.3755 6.40869C9.91437 6.46161 9.52368 6.52271 9.20361 6.59326C8.88597 6.66133 8.62322 6.75823 8.4165 6.88428C8.21231 7.0078 8.04743 7.17504 7.92139 7.38428C7.79547 7.5934 7.69284 7.86018 7.61475 8.18506C7.5366 8.51026 7.46683 8.91172 7.40381 9.38818C7.39119 9.47888 7.35393 9.55109 7.29346 9.604C7.23314 9.65915 7.16144 9.68691 7.07861 9.68701C6.99812 9.68701 6.92711 9.65922 6.8667 9.604C6.80628 9.55114 6.76859 9.48015 6.75342 9.39209C6.69544 8.99378 6.6348 8.65018 6.57178 8.36279C6.50877 8.07555 6.43105 7.83099 6.34033 7.62939C6.2496 7.42787 6.13793 7.26 6.00439 7.12646C5.87082 6.99289 5.70445 6.88306 5.50537 6.79736C5.30621 6.70913 5.06506 6.6366 4.78271 6.57861C4.5004 6.51812 4.16641 6.46163 3.78076 6.40869C3.69001 6.39861 3.61511 6.36275 3.55713 6.30225C3.50194 6.23941 3.47423 6.16636 3.47412 6.0835C3.47412 5.99788 3.50319 5.92423 3.56104 5.86377C3.61902 5.80075 3.69253 5.76448 3.78076 5.75439C4.24444 5.70399 4.63506 5.64331 4.95264 5.57275C5.2728 5.50217 5.53555 5.40527 5.73975 5.28174C5.94394 5.15821 6.10882 4.99098 6.23486 4.78174C6.36077 4.57263 6.46202 4.30583 6.5376 3.98096C6.61575 3.65575 6.68787 3.25291 6.75342 2.77393C6.76858 2.68587 6.8049 2.61487 6.86279 2.56201C6.92322 2.50676 6.99558 2.479 7.07861 2.479Z" fill="black"/></svg>',
    },
    type: 'backend_plugin',
    isPro: true,
  },
  {
    label: 'Meetings',
    value: 'search_audio_notes',
    images: {
      image:
        'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiNmZmZmZmYiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0ibHVjaWRlIGx1Y2lkZS1hdWRpby1saW5lcy1pY29uIGx1Y2lkZS1hdWRpby1saW5lcyI+PHBhdGggZD0iTTIgMTB2MyIvPjxwYXRoIGQ9Ik02IDZ2MTEiLz48cGF0aCBkPSJNMTAgM3YxOCIvPjxwYXRoIGQ9Ik0xNCA4djciLz48cGF0aCBkPSJNMTggNXYxMyIvPjxwYXRoIGQ9Ik0yMiAxMHYzIi8+PC9zdmc+',
    },
    type: 'backend_plugin',
    isPro: false,
  },
  {
    label: 'Knowledge Base',
    value: 'search_knowledge',
    images: {
      image:
        'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiNmZmZmZmYiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0ibHVjaWRlIGx1Y2lkZS1kb2N1bWVudC10ZXh0LWljb24gbHVjaWRlLWZpbGUtdGV4dCI+PHBhdGggZD0iTTE0IDJINmEyIDIgMCAwIDAtMiAydjE2YTIgMiAwIDAgMCAyIDJoMTJhMiAyIDAgMCAwIDItMlY4eiIvPjxwYXRoIGQ9Ik0xNCAydjRhMiAyIDAgMCAwIDIgMmg0Ii8+PC9zdmc+',
    },
    type: 'backend_plugin',
    isPro: false,
  },
  {
    label: 'Highlights',
    value: 'search_highlights',
    images: {
      image:
        'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiNmZmZmZmYiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0ibHVjaWRlIGx1Y2lkZS1saXN0LXRvZG8taWNvbiBsdWNpZGUtbGlzdC10b2RvIj48cGF0aCBkPSJNMTMgNWg4Ii8+PHBhdGggZD0iTTEzIDEyaDgiLz48cGF0aCBkPSJNMTMgMTloOCIvPjxwYXRoIGQ9Im0zIDE3IDIgMiA0LTQiLz48cmVjdCB4PSIzIiB5PSI0IiB3aWR0aD0iNiIgaGVpZ2h0PSI2IiByeD0iMSIvPjwvc3ZnPg==',
    },
    type: 'backend_plugin',
    isPro: false,
  },
]
